import { render, staticRenderFns } from "./InsMenuLayout.vue?vue&type=template&id=3c983e5b&scoped=true"
import script from "./InsMenuLayout.vue?vue&type=script&lang=ts"
export * from "./InsMenuLayout.vue?vue&type=script&lang=ts"
import style0 from "./InsMenuLayout.vue?vue&type=style&index=0&id=3c983e5b&prod&lang=less"
import style1 from "./InsMenuLayout.vue?vue&type=style&index=1&id=3c983e5b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c983e5b",
  null
  
)

export default component.exports